module.exports = __webpack_public_path__ + "img/slots24.4df00eff.jpg";